export type ItemProfessionalRow = { item_id: string; professional_id: string };

/** Item → profissionais que ganham comissão nele (linhas de commission_item_professionals). */
export function toItemProfessionalMap(rows: ItemProfessionalRow[]): Map<string, Set<string>> {
  const map = new Map<string, Set<string>>();
  for (const row of rows) {
    const set = map.get(row.item_id) ?? new Set<string>();
    set.add(row.professional_id);
    map.set(row.item_id, set);
  }
  return map;
}
